import { __rest, __assign, __makeTemplateObject } from '../../../../../../node_modules/tslib/tslib.es6.js';
import React__default from 'react';
import { styled, Link } from '@mui/material';

var ZigLink = styled(function (_a) {
    var rel = _a.rel, _b = _a.target, target = _b === void 0 ? "_blank" : _b, _c = _a.underline, underline = _c === void 0 ? "hover" : _c, props = __rest(_a, ["rel", "target", "underline"]);
    return (React__default.createElement(Link, __assign({ underline: underline, rel: rel || "noopener noreferrer", target: target }, props)));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;

export { ZigLink as default };
